export enum IPNSOrganizationType {
  HEALTH_SYSTEM,
  HOSPITAL,
  INSURANCE_ORGANIZATION,
}
